<template>
  <div>
    <Multiselect
      class="multiselect-custom-input"
      v-model="value"
      :close-on-select="false"
      :searchable="true"
      :options="options"
      :loading="loading"
      :disabled="isDisabled || false"
    />
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';

export default {
  props: ['modelValue', 'isDisabled', 'level'],
  emits: ['onChange'],
  components: {
    Multiselect
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
    value() {
      let obj = this.options.find((o) => o.value == this.value);
      this.$emit('onChange', this.value, obj?.data);
    },
    level() {
      this.$emit('onChange', null);
      this.getOptions();
    }
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      this.loading = true;
      this.$api
        .get('api/partner/all')
        .then((res) => {
          this.loading = false;
          this.options = res.data
            .filter((b) => {
              if (this.level) {
                return b.level == this.level;
              }
              return true;
            })
            .map((b) => {
              return { value: b.id, label: b.name, data: b };
            });
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  data() {
    return {
      loading: false,
      value: null,
      options: []
    };
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
